import React, { useState } from "react";
import { connect } from "react-redux";
import labResultImage from "../../../../../../../../assets/medical-record/requests/labResult.png";
import { useParams, useHistory } from "react-router-dom";

import {
  getSingleConsultations,
  requestScan,
} from "../../../../../../../../store/actions";

import AddRequest from "../../Repeated-Component/request";

import * as Yup from "yup";
import { useToast } from "@chakra-ui/react";

const Schema = Yup.object().shape({
  title: Yup.string().min(4).required("Required"),
  body: Yup.string().min(4).required("Required"),
});

const RequestLapResult = ({
  requestScan,
  requestedSacn,
  getSingleConsultations,
}) => {
  const history = useHistory();
  const toast = useToast();
  let { id } = useParams();

  const [initValue] = useState({
    title: "",
    body: "",
    scan_type: "lab_result",
    consultationId: id,
  });

  const onFormSubmit = (value) => {
    requestScan(value, toast, getSingleConsultations, id, null, history);
  };
  return (
    <AddRequest
      Schema={Schema}
      initValue={initValue}
      history={history}
      onFormSubmit={onFormSubmit}
      headerText={`Request Lab Result`}
      secondHeaderText="Lab Result"
      therdHeaderText="Request Lab Result"
      image={labResultImage}
      feildsNames={{
        feild1: {
          name: "title",
          type: "text",
          placeholder: "Title",
        },
        feild2: {
          name: "body",
          type: "text",
          placeholder: "Note",
        },
      }}
      btnLoading={requestedSacn.loading}
    />
  );
};
const mapStateToProps = (state) => {
  return {
    requestedSacn: state.requestedSacn,
  };
};
export default connect(mapStateToProps, {
  requestScan,
  getSingleConsultations,
})(RequestLapResult);
